// extracted by mini-css-extract-plugin
export var previewContainer = "_sb-0";